import { AsyncPipe, LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { GroupSelectComponent, GroupSelectOptionComponent } from '@rma/generic/ui/forms/group-select';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { filter, take } from 'rxjs';
import { WhenToSellOptionType, WhenToSellOptions } from '../domain/when-to-sell-options';
import { FindMyAgentStore } from '../orc-find-my-agent/find-my-agent.store';

@Component({
  selector: 'rma-when-to-sell',
  imports: [
    AsyncPipe,
    GroupSelectComponent,
    GroupSelectOptionComponent,
    LowerCasePipe,
    RmaIconComponent,
    ReactiveFormsModule,
    TranslocoModule,
  ],
  templateUrl: './when-to-sell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhenToSellComponent {
  protected readonly store = inject(FindMyAgentStore);

  protected readonly options = WhenToSellOptions;
  protected readonly control = new FormControl<WhenToSellOptionType | null>(null, [Validators.required]);

  constructor() {
    this.control.valueChanges
      .pipe(filter(Boolean), take(1))
      .subscribe((whenToSell) => this.store.patchState({ whenToSell, nextStep: 'address' }));
  }
}
